import React from 'react';

/** Highlight stat box — matches inverted cards on the About page hero */
const HeroHighlightCard = ({ value, label }) => (
  <div className="rounded-2xl p-6 border shadow-sm text-center h-full bg-white/10 border-white/20 backdrop-blur-sm">
    <div className="text-3xl md:text-4xl font-bold mb-2 text-primary-light">{value}</div>
    <div className="text-sm leading-snug text-gray-300">{label}</div>
  </div>
);

export default HeroHighlightCard;
